import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, ofType, createEffect } from '@ngrx/effects';

import * as actions from '../actions';
import * as Services from '@shared/core/services';

import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class OrderTypesEffects {
    public requestOrderTypes$: Observable<Action> = createEffect(() =>
        this._actions$.pipe(
            ofType(actions.OrderTypesRequest),
            switchMap(() =>
                this._onlineOrdersService.getOnlineOrdersOrderTypes().pipe(
                    map((payload) => actions.OrderTypesSuccessRequest({ payload })),
                    catchError((ex) => {
                        console.error('OrderTypes request error', ex);

                        return [actions.OrderTypesErrorRequest()];
                    }),
                ),
            ),
        ),
    );

    public resetOnlineOrderType$: Observable<Action> = createEffect(() =>
        this._actions$.pipe(
            ofType(actions.CurrentLocationSet),
            switchMap(() => [actions.OnlineOrderTypeSelect({ orderType: null })]),
        ),
    );

    constructor(private _actions$: Actions, private _onlineOrdersService: Services.OnlineOrdersService) {}
}
